import React, { useState } from 'react';

// Сначала письма с логотипами, потом без
const letters = [
  // --- С логотипами ---
  { src: '/images/letters/AUTOPROFI.webp', logo: '/images/letters/logos/AUTOPROFI.webp', name: 'AUTOPROFI', desc: 'Благодарность за увеличение продаж и выход в ТОП', logoBg: '#FFFFFF' },
  { src: '/images/letters/GW.webp', logo: '/images/letters/logos/GW.webp', name: 'GREENWORKS', desc: 'Благодарность за комплексное ведение магазина' },
  { src: '/images/letters/KLVLX.webp', logo: '/images/letters/logos/KLVLX.webp', name: 'KLVLX Сумки', desc: 'Благодарность за рост оборота и прибыли', logoBg: '#FFFFFF' },
  { src: '/images/letters/Letta.webp', logo: '/images/letters/logos/Letta.webp', name: 'LETTA Мебель', desc: 'Отзыв об эффективной рекламной стратегии' },
  { src: '/images/letters/NR.webp', logo: '/images/letters/logos/NR.webp', name: 'MOYORY', desc: 'Рост магазина с 100к до 46М в месяц' },
  { src: '/images/letters/OBI.webp', logo: '/images/letters/logos/OBI.webp', name: 'OBI', desc: 'Благодарность за выполнение KPI' },
  { src: '/images/letters/REDsolution.webp', logo: '/images/letters/logos/REDsolution.webp', name: 'RED Solution', desc: 'Рекомендательное письмо от партнёра' },
  { src: '/images/letters/Resanta.webp', logo: '/images/letters/logos/Resanta.webp', name: 'Resanta', desc: 'Благодарность за масштабирование на Ozon и WB' },
  { src: '/images/letters/REXANT.webp', logo: '/images/letters/logos/REXANT.webp', name: 'REXANT', desc: 'Отзыв об увеличении конверсии карточек' },
  { src: '/images/letters/TERMINUS.webp', logo: '/images/letters/logos/TERMINUS.webp', name: 'TERMINUS', desc: 'Рекомендация по итогам успешного сотрудничества' },
  { src: '/images/letters/Wirquin.webp', logo: '/images/letters/logos/Wirquin.webp', name: 'Wirquin', desc: 'Благодарность за профессиональный подход' },
  { src: '/images/letters/ZITREK.webp', logo: '/images/letters/logos/ZITREK.webp', name: 'ZITREK', desc: 'Отзыв о комплексном ведении на маркетплейсах' },
  { src: '/images/letters/VirkenRus.webp', logo: '/images/letters/logos/VirkenRus.webp', name: 'Виркэн-Рус', desc: 'Благодарность за выход в ТОП категории' },
  { src: '/images/letters/DobroStroy.webp', logo: '/images/letters/logos/DobroStroy.webp', name: 'ДоброСтрой', desc: 'Рекомендательное письмо от крупного клиента' },
  { src: '/images/letters/Unikom.webp', logo: '/images/letters/logos/Unikom.webp', name: 'Юником', desc: 'Благодарность за стратегию продвижения' },
  // --- Без логотипов (фоллбек — первая буква) ---
  { src: '/images/letters/ARTKIT.webp', logo: '/images/letters/logos/ARTKIT.webp', name: 'АРТКИТ Китайские чаи', desc: 'Благодарственное письмо за качественное продвижение на маркетплейсах' },
  { src: '/images/letters/Avtaev.webp', logo: '/images/letters/logos/Avtaev.webp', name: 'АВТАЕВ Товары для дома', desc: 'Отзыв о сотрудничестве и росте показателей' },
  { src: '/images/letters/ElCastle.webp', logo: '/images/letters/logos/ElCastle.webp', name: 'ELCASTLE Смартфоны', desc: 'Рекомендательное письмо по итогам работы' },
  { src: '/images/letters/HomeFactor.webp', logo: '/images/letters/logos/HomeFactor.webp', name: "Home's Factor", desc: 'Письмо о результатах продвижения бренда' },
  { src: '/images/letters/noti.webp', logo: '/images/letters/logos/noti.webp', name: 'NO TI Аромадиффузоры', desc: 'Благодарственное письмо за профессионализм' },
  { src: '/images/letters/Ovsinnikov.webp', logo: '/images/letters/logos/Ovsinnikov.webp', name: 'Овсинников', desc: 'Отзыв о работе с маркетплейсами' },
  { src: '/images/letters/Pugachev.webp', logo: '/images/letters/logos/Pugachev.webp', name: 'Пугачев', desc: 'Благодарность за стабильный рост продаж' },
  { src: '/images/letters/Rumyantsev.webp', logo: '/images/letters/logos/Rumyantsev.webp', name: 'Румянцев', desc: 'Благодарственное письмо за результаты' },
  { src: '/images/letters/Popova.webp', logo: '/images/letters/logos/Popova.webp', name: 'ИП Попова', desc: 'Отзыв об увеличении прибыли в 3 раза' },
];

const LettersSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedLetter, setSelectedLetter] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);

  const perPage = 6;

  const goTo = (dir) => {
    setCurrentIndex((prev) => {
      if (dir === 'next') return (prev + perPage) % letters.length;
      return (prev - perPage + letters.length) % letters.length;
    });
  };

  const getVisible = () => {
    const items = [];
    for (let i = 0; i < perPage; i++) {
      let idx = (currentIndex + i) % letters.length;
      items.push({ ...letters[idx], idx });
    }
    return items;
  };

  const totalPages = Math.ceil(letters.length / perPage);
  const currentPage = Math.floor(currentIndex / perPage) + 1;

  return (
    <section
      style={{
        background: '#FFFFFF',
        padding: '80px 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные glow */}
      <div style={{
        position: 'absolute', width: 400, height: 400, top: -150, left: -100,
        borderRadius: '50%', background: 'linear-gradient(135deg, #22D3EE, #8B5CF6)',
        filter: 'blur(140px)', opacity: 0.06, pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', width: 350, height: 350, bottom: -100, right: -80,
        borderRadius: '50%', background: 'linear-gradient(135deg, #EC4899, #FBBF24)',
        filter: 'blur(120px)', opacity: 0.05, pointerEvents: 'none',
      }} />

      {/* Декоративные иконки на фоне */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none', zIndex: 0 }}>
        <img loading="lazy" src="/images/icons/trophy.webp" alt="" className="letters-bg-icon letters-bg-icon-1" />
        <img loading="lazy" src="/images/icons/star.webp" alt="" className="letters-bg-icon letters-bg-icon-2" />
        <img loading="lazy" src="/images/icons/rocket.webp" alt="" className="letters-bg-icon letters-bg-icon-3" />
        <img loading="lazy" src="/images/icons/chart.webp" alt="" className="letters-bg-icon letters-bg-icon-4" />
        <img loading="lazy" src="/images/icons/crown.webp" alt="" className="letters-bg-icon letters-bg-icon-5" />
        <img loading="lazy" src="/images/icons/wallet.webp" alt="" className="letters-bg-icon letters-bg-icon-6" />
      </div>

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', position: 'relative', zIndex: 2 }}>
        {/* Заголовок */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 48, flexWrap: 'wrap', gap: 24 }}>
          <div>
            <span style={{
              background: 'rgba(15,15,26,0.06)', color: '#0F0F1A',
              fontSize: 14, fontWeight: 500, padding: '12px 24px',
              borderRadius: 50, textTransform: 'uppercase', letterSpacing: '0.05em',
              display: 'inline-block', marginBottom: 20,
            }}>
              БЛАГОДАРНОСТИ
            </span>
            <h2 style={{
              fontSize: 'clamp(32px, 5vw, 48px)', fontWeight: 800,
              color: '#0F0F1A', textTransform: 'uppercase',
              lineHeight: 1.1, margin: 0,
            }}>
              ПИСЬМА{' '}
              <span style={{
                background: 'linear-gradient(90deg, #22D3EE, #8B5CF6, #EC4899)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              }}>
                ОТ КЛИЕНТОВ
              </span>
            </h2>
          </div>

          {/* Навигация */}
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <span style={{ color: 'rgba(0,0,0,0.35)', fontSize: 14, marginRight: 8 }}>
              {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => goTo('prev')}
              style={{
                width: 48, height: 48, borderRadius: '50%', border: '1px solid rgba(0,0,0,0.12)',
                background: 'transparent', color: '#0F0F1A', fontSize: 18, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(139,92,246,0.08)';
                e.currentTarget.style.borderColor = 'rgba(139,92,246,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(0,0,0,0.12)';
              }}
            >
              ←
            </button>
            <button
              onClick={() => goTo('next')}
              style={{
                width: 48, height: 48, borderRadius: '50%', border: 'none',
                background: 'linear-gradient(135deg, #22D3EE, #8B5CF6)', color: '#FFFFFF',
                fontSize: 18, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(139,92,246,0.25)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.boxShadow = '0 6px 25px rgba(139,92,246,0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(139,92,246,0.25)';
              }}
            >
              →
            </button>
          </div>
        </div>

        {/* Карточки */}
        <div className="letters-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20 }}>
          {getVisible().map((letter, i) => (
            <div
              key={`${letter.name}-${letter.idx}`}
              onMouseEnter={() => setHoveredCard(i)}
              onMouseLeave={() => setHoveredCard(null)}
              style={{
                background: '#FFFFFF',
                border: hoveredCard === i
                  ? '1px solid rgba(139,92,246,0.25)'
                  : '1px solid rgba(0,0,0,0.08)',
                borderRadius: 20,
                overflow: 'hidden',
                transition: 'all 0.4s ease',
                transform: hoveredCard === i ? 'translateY(-6px)' : 'translateY(0)',
                boxShadow: hoveredCard === i
                  ? '0 20px 50px rgba(139,92,246,0.12), 0 0 40px rgba(34,211,238,0.06)'
                  : '0 4px 20px rgba(0,0,0,0.06)',
              }}
            >
              {/* Верхняя часть — скан письма */}
              <div
                onClick={() => setSelectedLetter(letter)}
                style={{
                  height: 280,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  position: 'relative',
                }}
              >
                <img
                  src={letter.src}
                  alt={letter.name}
                  loading="lazy"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'top',
                    transition: 'transform 0.4s ease',
                    transform: hoveredCard === i ? 'scale(1.03)' : 'scale(1)',
                  }}
                />
                {/* Градиент для перехода */}
                <div style={{
                  position: 'absolute', bottom: 0, left: 0, right: 0, height: 60,
                  background: 'linear-gradient(transparent, rgba(255,255,255,0.8))',
                  pointerEvents: 'none',
                }} />
                {/* Иконка увеличения */}
                <div style={{
                  position: 'absolute', top: 12, right: 12,
                  width: 32, height: 32, borderRadius: '50%',
                  background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  opacity: hoveredCard === i ? 1 : 0,
                  transition: 'opacity 0.3s ease',
                  color: '#fff', fontSize: 14,
                }}>
                  🔍
                </div>
              </div>

              {/* Нижняя часть — логотип + текст */}
              <div style={{ padding: '20px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 12,
                  background: letter.logoBg || '#F5F5F7',
                  border: '1px solid rgba(0,0,0,0.06)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  overflow: 'hidden', flexShrink: 0,
                }}>
                  <img
                    src={letter.logo}
                    alt=""
                    loading="lazy"
                    style={{ width: '100%', height: '100%', objectFit: 'contain', padding: 6 }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = `<span style="color:#8B5CF6;font-size:18px;font-weight:800">${letter.name.charAt(0)}</span>`;
                    }}
                  />
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{
                    color: '#0F0F1A', fontSize: 15, fontWeight: 700,
                    textTransform: 'uppercase', letterSpacing: '0.03em',
                    marginBottom: 4,
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                  }}>
                    {letter.name}
                  </div>
                  <div style={{
                    color: 'rgba(0,0,0,0.45)', fontSize: 13, lineHeight: 1.4,
                    display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}>
                    {letter.desc}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Модалка */}
      {selectedLetter && (
        <div
          onClick={() => setSelectedLetter(null)}
          style={{
            position: 'fixed', inset: 0,
            background: 'rgba(0,0,0,0.88)', backdropFilter: 'blur(10px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, cursor: 'pointer',
          }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{
            position: 'relative', maxWidth: '90vw', maxHeight: '90vh',
            borderRadius: 16, overflow: 'hidden',
            border: '1px solid rgba(139,92,246,0.3)',
            boxShadow: '0 30px 80px rgba(0,0,0,0.5), 0 0 100px rgba(139,92,246,0.1)',
          }}>
            <img
              src={selectedLetter.src}
              alt={selectedLetter.name}
              style={{ maxWidth: '90vw', maxHeight: '85vh', objectFit: 'contain', display: 'block' }}
            />
            <div style={{
              position: 'absolute', bottom: 0, left: 0, right: 0,
              padding: '40px 24px 20px',
              background: 'linear-gradient(transparent, rgba(0,0,0,0.9))',
            }}>
              <span style={{ color: '#fff', fontSize: 16, fontWeight: 700, textTransform: 'uppercase' }}>
                {selectedLetter.name}
              </span>
            </div>
            <button
              onClick={() => setSelectedLetter(null)}
              style={{
                position: 'absolute', top: 12, right: 12,
                width: 40, height: 40, borderRadius: '50%',
                background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#FFFFFF', fontSize: 18, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(139,92,246,0.4)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(0,0,0,0.6)'; }}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      <style>{`
        .letters-bg-icon {
          position: absolute;
          opacity: 0.05;
          filter: blur(1px) grayscale(0.3);
        }

        .letters-bg-icon-1 {
          width: 100px; height: 100px;
          top: 8%; left: 4%;
          transform: rotate(-12deg);
          animation: lettersFloat1 6s ease-in-out infinite;
        }
        .letters-bg-icon-2 {
          width: 100px; height: 100px;
          top: 5%; right: 5%;
          transform: rotate(10deg);
          animation: lettersFloat2 7s ease-in-out infinite;
        }
        .letters-bg-icon-3 {
          width: 100px; height: 100px;
          bottom: 10%; left: 5%;
          transform: rotate(8deg);
          animation: lettersFloat3 5.5s ease-in-out infinite;
        }
        .letters-bg-icon-4 {
          width: 100px; height: 100px;
          bottom: 12%; right: 4%;
          transform: rotate(-8deg);
          animation: lettersFloat4 6.5s ease-in-out infinite;
        }
        .letters-bg-icon-5 {
          width: 100px; height: 100px;
          top: 50%; left: 2%;
          transform: rotate(15deg);
          animation: lettersFloat5 7s ease-in-out infinite;
        }
        .letters-bg-icon-6 {
          width: 100px; height: 100px;
          top: 45%; right: 3%;
          transform: rotate(-10deg);
          animation: lettersFloat6 6s ease-in-out infinite;
        }

        @keyframes lettersFloat1 {
          0%, 100% { transform: translate(0, 0) rotate(-15deg); }
          50% { transform: translate(-8px, -12px) rotate(-15deg); }
        }
        @keyframes lettersFloat2 {
          0%, 100% { transform: translate(0, 0) rotate(12deg); }
          50% { transform: translate(10px, -10px) rotate(12deg); }
        }
        @keyframes lettersFloat3 {
          0%, 100% { transform: translate(0, 0) rotate(8deg); }
          50% { transform: translate(-12px, -8px) rotate(8deg); }
        }
        @keyframes lettersFloat4 {
          0%, 100% { transform: translate(0, 0) rotate(-10deg); }
          50% { transform: translate(10px, -14px) rotate(-10deg); }
        }
        @keyframes lettersFloat5 {
          0%, 100% { transform: translate(0, 0) rotate(18deg); }
          50% { transform: translate(-6px, -10px) rotate(18deg); }
        }
        @keyframes lettersFloat6 {
          0%, 100% { transform: translate(0, 0) rotate(-8deg); }
          50% { transform: translate(8px, -12px) rotate(-8deg); }
        }

        @media (max-width: 1024px) {
          .letters-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 768px) {
          .letters-bg-icon { display: none; }
        }
        @media (max-width: 640px) {
          .letters-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default LettersSlider;
